// extracted by mini-css-extract-plugin
module.exports = {"root":"total_root__2U-Pp"};